import request from '@/utils/request'

const newContract = {
  // 查询合同管理列表
  listContract(query) {
    return request({
      url: '/cont/newContract/list',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  listPayment(query) {
    return request({
      url: '/cont/newContract/listPayment',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 合同统计符合条件的列表
  listContractQuery(query) {
    return request({
      url: '/cont/newContract/getContNewContractList',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 查询合同管理详细
  getContract(contractId) {
    return request({
      url: '/cont/newContract/' + contractId,
      method: 'get',
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 新增合同管理
  addContract(data) {
    console.log('contract:' + JSON.stringify(data))
    return request({
      url: '/cont/newContract',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 修改合同管理
  updateContract(data) {
    // console.log('contract:' + JSON.stringify(data))
    return request({
      url: '/cont/newContract',
      method: 'put',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 管理员修改
  editAdminContract(data) {
    // console.log('contract:' + JSON.stringify(data))
    return request({
      url: '/cont/newContract/editAdmin',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 业务员限时修改
  editBussContract(data) {
    return request({
      url: '/cont/newContract/editBuss',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 删除合同管理
  deleteContract(contractId) {
    return request({
      url: '/cont/newContract/' + contractId,
      method: 'delete',
      options: {
        loading: true
      }
    })
  },
  // 上传审批附件
  ucloudUpFileToContract(data) {
    return request({
      url: '/cont/newContract/upload',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  uploadContractFile(data) {
    return request({
      url: '/common/upload',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 用章申请
  sealApproval(data) {
    return request({
      url: '/cont/newContract/spApply',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 根据用户ID获取商机列表信息,合同数据存在的商机信息不查询出来
  getBoListByUserId(query) {
    return request({
      url: '/cont/newContract/getBoListByUserIdNew',
      method: 'get',
      params: query
    })
  },

  // 查询返点百分比列表
  getRebateList(query) {
    return request({
      url: '/cont/point/list',
      method: 'get',
      params: query
    })
  },
  // 新增返点百分比
  addRebate(data, contractId) {
    return request({
      url: '/cont/point/' + contractId,
      method: 'post',
      data: data
    })
  },
  // 修改返点百分比
  updateRebate(data) {
    return request({
      url: '/cont/point',
      method: 'put',
      data: data
    })
  },
  // 删除返点百分比
  deleteRebate(rebateId) {
    return request({
      url: '/cont/point/' + rebateId,
      method: 'delete'
    })
  },

  // 查询合同附件列表
  listContractFile(query) {
    return request({
      url: '/cont/file/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 查询合同附件详细
  getContractFile(id) {
    return request({
      url: '/cont/file/' + id,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 新增合同附件
  addContractFile(data) {
    return request({
      url: '/cont/file',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 新增合同附件
  addContractFile2(data) {
    return request({
      url: '/cont/file/addFile',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 修改合同附件
  updateContractFile(data) {
    return request({
      url: '/cont/file',
      method: 'put',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 删除合同附件
  deleteContractFile(id) {
    return request({
      url: '/cont/file/' + id,
      method: 'delete',
      options: {
        loading: true
      }
    })
  },

  // 查询收款约定列表
  listPayAgree(query) {
    return request({
      url: '/cont/agree/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 查询收款约定详细
  getPayAgree(payAgreeId) {
    return request({
      url: '/cont/agree/' + payAgreeId,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 新增收款约定
  addPayAgree(data) {
    return request({
      url: '/cont/agree',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 修改收款约定
  updatePayAgree(data) {
    return request({
      url: '/cont/agree',
      method: 'put',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 删除收款约定
  deletePayAgree(payAgreeId) {
    return request({
      url: '/cont/agree/' + payAgreeId,
      method: 'delete',
      options: {
        loading: true
      }
    })
  },
  // 合同操作记录(日志)
  listContractLog(query) {
    return request({
      url: '/cont/log/list',
      method: 'get',
      params: query
    })
  },
  // 签署归档
  placeFile(data) {
    return request({
      url: '/cont/newContract/placeFile',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 用章审批申请
  spApply(data) {
    return request({
      url: '/cont/newContract/spApply',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 垫款审批申请
  dkApply(data) {
    return request({
      url: '/cont/newContract/dkApply',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 用印申请
  yyApply(data) {
    return request({
      url: '/cont/newContract/yyApply',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 根据审批编号查询审批详情列表
  listVerify(query) {
    return request({
      url: '/admi/verify/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },

  // 查询用户可使用的申领合同数量
  getContractNum(data) {
    return request({
      url: '/cont/newContract/getContractNumCount',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },

  // 查询审批页面总数
  getVerifyCount(query) {
    return request({
      url: '/cont/newContract/getContCount',
      method: 'get',
      params: query
    })
  },

  // 合同附件图片转pdf
  fjPostContractid(data) {
    return request({
      url: '/common/uploadPDF',
      method: 'post',
      data: data
    })
  },
  // 根据客户ID获取联系人列表
  getContacts(data) {
    return request({
      url: '/scrm/contact/getContactListByCustId',
      method: 'post',
      data: data
    })
  },
  // 合同催审
  contUrge(contractId, type) {
    return request({
      url: '/qywechat/cuiShen/' + contractId + '/' + type,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 获取投放链路/媒体版位树数据
  getTreeData(query) {
    return request({
      url: '/cont/link/listAll',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },

  // 合同更改跟进人
  batchInherit(data) {
    return request({
      url: '/cont/newContract/batchInherit',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },

  // 查询项目名称列表
  listProject(query) {
    return request({
      url: '/cont/project/list',
      method: 'get',
      params: query
    })
  },
  // 查询项目名称列表
  listProjectPercentage(query) {
    return request({
      url: '/cont/project/listPoint',
      method: 'get',
      params: query
    })
  },
  // 获取项目名称列表详细信息
  getProject(projectId) {
    return request({
      url: '/cont/project/' + projectId,
      method: 'get'
    })
  },
  // 新增项目名称
  addProject(data) {
    return request({
      url: '/cont/project',
      method: 'post',
      data: data
    })
  },
  // 修改项目名称
  updateProject(data) {
    return request({
      url: '/cont/project',
      method: 'put',
      data: data
    })
  },
  // 删除项目名称
  delProject(projectId) {
    return request({
      url: '/cont/project/' + projectId,
      method: 'delete'
    })
  },

  // 修改合同执行时间
  editExecTime(data) {
    return request({
      url: '/cont/newContract/editExecTime',
      method: 'post',
      data: data
    })
  },

  // 合同归档合同查询列表
  getConContractExportList(query) {
    return request({
      url: '/cont/newContract/getConContractExportList',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 合同归档合同查询列表tab显示数量
  getContractSum(query) {
    return request({
      url: '/cont/newContract/getConContractExportListSum',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  }
}

export default newContract
